/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type TagProject_viewer$ref = any;
export type TagProject_viewer = {
    readonly id: string;
    readonly projects: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
                readonly name: string | null;
                readonly portfolio: {
                    readonly serviceId: string | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly user: {
        readonly tradeFirm: {
            readonly serviceId: string | null;
        } | null;
    } | null;
    readonly " $refType": TagProject_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v1 = [
        (v0 /*: any*/)
    ];
    return {
        "kind": "Fragment",
        "name": "TagProject_viewer",
        "type": "Viewer",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "forward",
                    "path": [
                        "projects"
                    ]
                }
            ]
        },
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userIds",
                "type": "[String]"
            },
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String!"
            }
        ],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": "projects",
                "name": "__TagProject_projects_connection",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "userIds",
                        "variableName": "userIds"
                    }
                ],
                "concreteType": "ProjectConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProjectEdge",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Project",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "name",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "portfolio",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "PortfolioV2",
                                        "plural": false,
                                        "selections": (v1 /*: any*/)
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "__typename",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cursor",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pageInfo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endCursor",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasNextPage",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "userId",
                        "variableName": "userId"
                    }
                ],
                "concreteType": "User",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirm",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "plural": false,
                        "selections": (v1 /*: any*/)
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'e6cacb73154ac85a75f320758cbc7794';
export default node;
